import React from "react";
import { Container } from "react-bootstrap";
import { Link } from "react-router-dom";

function StudentResourcesPage() {
  return (
    <Container fluid className="project-section career-utility-page">
      <Container className="career-utility-shell">
        <p className="career-utility-eyebrow">Student Resources</p>
        <h1 className="career-utility-title">Policies, Academic Support, and Student Success Tools</h1>
        <p className="career-utility-lead">
          Centralized resources for current and prospective learners in Choicest Fruit career pathways.
        </p>

        <section className="career-utility-card">
          <h2>Core Documents</h2>
          <ul>
            <li>School Catalog</li>
            <li>Enrollment Agreement</li>
            <li>Refund Policy</li>
            <li>Attendance Policy</li>
            <li>Complaint and Appeals Procedures</li>
            <li>Student Handbook</li>
            <li>Academic Calendar</li>
          </ul>
        </section>

        <section className="career-utility-card">
          <h2>Career Development Support</h2>
          <ul>
            <li>Resume and LinkedIn workshops</li>
            <li>Mock interviews and portfolio reviews</li>
            <li>Mentor office hours and capstone coaching</li>
            <li>Internship and workforce pathway guidance</li>
          </ul>
        </section>

        <section className="career-utility-card">
          <h2>Technology Access and Learning Tools</h2>
          <ul>
            <li>VS Code, GitHub, Node.js, and cloud collaboration platforms</li>
            <li>Design tools such as Figma and Canva</li>
            <li>Optional media and 3D tools for advanced tracks</li>
            <li>Learning management and virtual support tools</li>
          </ul>
        </section>

        <div className="career-utility-links">
          <Link to="/courses" className="custom-yellow-btn btn">Back to Career Programs</Link>
          <Link to="/admissions" className="btn btn-primary">View Admissions</Link>
          <Link to="/catalog" className="btn btn-primary">View Catalog</Link>
        </div>
      </Container>
    </Container>
  );
}

export default StudentResourcesPage;
